import React, { useState, useEffect } from "react";
import { Button, Space, Table, Input, Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCampaigns } from "../../Redux/CampaignSlice";
import moment from "moment";
import { debounce } from 'lodash';
import { useCallback } from 'react';

const { Search } = Input;

const DashboardTable = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { campaigns, totalDocs } = useSelector((state) => state.campaign);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [sortTitle, setSortTitle] = useState(null);
  const [sortValue, setSortValue] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  useEffect(() => {
    dispatch(
      fetchCampaigns({
        page: pagination.current,
        limit: pagination.pageSize,
        sortTitle,
        sortValue,
        search:searchTerm,
      })
    );
  }, [
    dispatch,
    pagination.current,
    pagination.pageSize,
    sortTitle,
    sortValue,
    searchTerm,
  ]);

  const handleMenuClick = (key, record, event) => {
    if (key === "edit") {
      navigate(`/dashboard/campaigns/edit/${record._id}`);
      event.stopPropagation(); // Stop the parent row click event
    } else if (key === "view") {
      navigate(`/dashboard/campaign-detail/${record._id}`);
    } else if (key === "statistics") {
      console.log("Statistics clicked", record);
    } else if (key === "fundraiser") {
      console.log("Fundraiser clicked", record);
    }
  };
  

  const dropdownItems = (record) => [
    { key: "view", label: "View" },
    { key: "statistics", label: "Statistics" },
    { key: "fundraiser", label: "Fundraiser" },
    { key: "edit", label: "Edit" },
  ];

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
    setPagination({ ...pagination, current: pagination.current });
  };


  
  const handleSearch = useCallback(
    debounce((value) => {
      setSearchTerm(value);
      setPagination((prevPagination) => ({ ...prevPagination, current: 1 }));
    }, 300), 
    []
  );
  
  const onSearch = (value) => {
    handleSearch(value);
  };
  

  const handleSort = (title) => {
    const newSortValue = sortTitle === title && sortValue === 1 ? -1 : 1;
    setSortTitle(title);
    setSortValue(newSortValue);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Goal",
      dataIndex: "goal",
      key: "goal",
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      render: (text) => moment(text).format("YYYY-MM-DD"),
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      render: (text) => moment(text).format("YYYY-MM-DD"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "...",
      key: "action",
      render: (text, record) => (
        <Dropdown
        menu={{
          items: dropdownItems(record),
          onClick: ({ key, domEvent }) => handleMenuClick(key, record, domEvent),
        }}
        trigger={["click"]}
        overlayClassName="custom-dropdown-menu list-none" // Add list-none here
      >
        <Button
          type="text"
          onClick={(e) => {
            e.stopPropagation(); // Prevent row click
          }}
        >
          ...
        </Button>
      </Dropdown>
      
      ),
    },
  ];

  return (
    <>
      <Space direction="vertical" style={{ marginBottom: 16 }} className="w-full">
        <div className="flex justify-between items-center">
          <div className="flex gap-2">
            <span className="text-gray-600">Sort</span>
            <button
              onClick={() => handleSort("name")}
              className="bg-green-100 px-3 rounded-l-lg h-7 border-r ml-4 text-sm"
            >
              Name: A-Z
            </button>
            <button
              onClick={() => handleSort("start_date")}
              className="bg-green-100 px-5 rounded-r-lg h-7 -ml-2 text-sm"
            >
              Date: A-Z
            </button>
          </div>
          <Search
            placeholder="Search Campaigns"
            onChange={(e) => onSearch(e.target.value)}
            style={{ width: 150 }}
            className="ml-auto sm:ml-0 "
          />
        </div>
      </Space>

      <Table
  columns={columns}
    dataSource={campaigns.map((campaign) => ({
      ...campaign,
      key: campaign._id,
    }))}
    onChange={handleChange}
    className="cursor-pointer list-none"
    onRow={(record) => ({
      onClick: () => navigate(`/dashboard/campaign-detail/${record._id}`),
    })}
    rowClassName={() => "list-none"} // Add list-none here to remove bullets from rows
    pagination={{
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: totalDocs,
    onChange: (page, pageSize) => {
      setPagination({ current: page, pageSize });
    },
  }}
  scroll={{ x: "max-content" }}
/>

    </>
  );
};

export default DashboardTable;
